import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/support/');


export async function sendSupport(data) {
    const form = new FormData();

    for (const doc of data.documents) {
        form.append('files', new File([ doc.file ], doc.value.name));
    }

    delete data.documents;
    form.set('json', JSON.stringify({ ...data }));

    const { result } = await doRequest('send', form, { blocking: true });
    return result;
}
